module.exports = "/_next/static/images/valerios-baglaridis-1c47e725d1276dfeab633ab0f6a01431.jpg";